export const GET_DATA_WAITING = "GET_DATA_WAITING"
export const GET_DATA_SUCCESS = "GET_DATA_SUCCESS"
export const GET_DATA_FAILED = "GET_DATA_FAILED"